import React from 'react';
import { MDBBtn, MDBCol, MDBContainer, MDBRow, MDBTypography } from 'mdbreact';
import { Language } from '../../../redux/store/base/language';
import { useSelector } from 'react-redux';

// Import asset
import "./Offer.scss";
import EX1 from "./../../../assets/images/female/ex1.png";
import EX2 from "./../../../assets/images/female/ex2.png";
import EX3 from "./../../../assets/images/female/ex3.png";
import EX4 from "./../../../assets/images/female/ex2.png";

const Offer = (props: OfferProps) => {

    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary?.homepage
    );

    return <MDBRow className="offer">
        <MDBCol sm="12">
            <h3 className="text-center mb-1">{dictionary?.offers}</h3>
        </MDBCol>
        <MDBCol sm="12" className="mt-3">
            <MDBContainer>
                <MDBRow center middle>
                    <MDBCol xs="12" sm="6" md="3" className="item">
                        <img src={EX1} alt="" />
                    </MDBCol>
                    <MDBCol xs="12" sm="6" md="3" className="item">
                        <img src={EX2} alt="" />
                    </MDBCol>
                    <MDBCol xs="12" sm="6" md="3" className="item">
                        <img src={EX3} alt="" />
                    </MDBCol>
                    <MDBCol xs="12" sm="6" md="3" className="item">
                        <img src={EX4} alt="" />
                    </MDBCol>
                    <MDBCol sm="12">
                        <MDBBtn outline>
                            {dictionary?.more_offer}
                        </MDBBtn>
                    </MDBCol>
                </MDBRow>
            </MDBContainer>
        </MDBCol>
    </MDBRow>
};

interface OfferProps { }
export default Offer;